'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCash = function IoCash(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm0 7.5h40v20h-40v-20z m15.1 17.5c-1.6-1.8-2.6-4.5-2.6-7.5s1-5.7 2.6-7.5h-7.6c0 2.7-2.3 5-5 5v6.3c2.1 0 3.8 1.6 3.8 3.7h8.8z m8.2-4.6c0.2-0.3 0.3-0.7 0.3-1.2 0-0.2 0-0.4-0.1-0.6s-0.1-0.5-0.3-0.6-0.3-0.3-0.5-0.5-0.5-0.3-0.8-0.4c-0.1 0-0.3-0.1-0.6-0.1s-0.4 0-0.6-0.1v-2.4c0.2 0 0.4 0.1 0.6 0.2 0.3 0.2 0.4 0.5 0.5 1h1.6c0-0.4-0.2-0.7-0.4-1s-0.3-0.6-0.7-0.9-0.7-0.4-1-0.4c-0.2-0.1-0.4-0.2-0.6-0.2v-0.7h-1.4v0.7c-0.2 0-0.3 0.1-0.5 0.2-0.4 0-0.8 0.1-1.1 0.3s-0.5 0.5-0.7 0.8-0.3 0.7-0.3 1.1c0 0.3 0 0.4 0.1 0.6s0.2 0.4 0.3 0.6 0.4 0.4 0.6 0.5 0.6 0.4 1 0.4c0.2 0.1 0.4 0 0.6 0.1v2.7c-0.2 0-0.5-0.1-0.7-0.3s-0.4-0.3-0.5-0.5-0.1-0.5-0.1-0.7h-1.6c0 0.4 0.2 0.8 0.3 1.2 0.3 0.4 0.5 0.7 0.8 0.9s0.7 0.5 1.2 0.5c0.2 0.1 0.4 0.2 0.6 0.2v0.7h1.4v-0.7c0.2 0 0.5-0.1 0.7-0.2 0.4 0 0.8-0.1 1.1-0.4s0.5-0.5 0.8-0.8z m14.2 0.9v-6.3c-2.7 0-5-2.3-5-5h-7.6c1.6 1.8 2.6 4.5 2.6 7.5s-1 5.7-2.6 7.5h8.9c0-2.1 1.7-3.7 3.7-3.7z m-32.5-3.8c0-1.6 0.9-2.5 2.5-2.5s2.5 0.9 2.5 2.5-0.9 2.5-2.5 2.5-2.5-0.9-2.5-2.5z m25 0c0-1.6 0.9-2.5 2.5-2.5s2.5 0.9 2.5 2.5-0.9 2.5-2.5 2.5-2.5-0.9-2.5-2.5z m-8.7 0.9c0.2 0 0.3 0.1 0.5 0.3s0.2 0.4 0.2 0.7c0 0.1 0 0.3 0 0.4s-0.2 0.4-0.4 0.4-0.3 0.3-0.6 0.3c-0.1 0-0.1 0.1-0.3 0.1v-2.4c0.2 0.1 0.5 0.1 0.6 0.2z m-2.9-3.5c0.1-0.1 0.3-0.2 0.4-0.3s0.3-0.1 0.5-0.1v2c-0.3-0.1-0.5-0.3-0.7-0.4s-0.3-0.3-0.3-0.6c0-0.3 0.1-0.4 0.1-0.6z m-18.4 17.6v-2.5h40v2.5h-40z' })
        )
    );
};

exports.default = IoCash;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/cash.js
// module id = 2458
// module chunks = 168707334958949